import * as types from '../../actions/types';

const initialState = {
  data: null,
  pageCount: 0
};

export default function list (state = initialState, action) {
  switch (action.type) {
    case types.SET_REVIEWS_LIST:
      return {
        ...state,
        data: action.payload,
        pageCount: action.pageCount
      };
    default:
      return state;
  }
}
